import SliderWrapper from "./SliderWrapper";

export default SliderWrapper;
